import { makeCrudStateActionFactories } from "seneca-common/utils/apiStates";
import {
  analyticsCategories,
  AnalyticsEventsRegister,
  makeAnalyticsEvent
} from "seneca-common/utils/senecaAnalytics";

import { feedbackCrudConfig } from "../consts";

const { createActionTypes } = makeCrudStateActionFactories(feedbackCrudConfig);

const makeFeedbackAnalyticsEvent = () =>
  makeAnalyticsEvent(analyticsCategories.FEEDBACK);

AnalyticsEventsRegister.addEventGenerators({
  // @ts-ignore
  [createActionTypes.CREATE_FEEDBACK_SUCCESS]: makeFeedbackAnalyticsEvent
});
